import gql from 'graphql-tag'
import client from '@stores/apollo'

import { BookingFragment, PageInfoFragment } from '@api/fragments'
import { IBookingsConnectionWithTotal } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

export interface IBookingVariables {
  first?: number
  orderBy: string
  after?: string | null
  where?: any
}

interface IPayload {
  viewer: {
    company: {
      bookingConnection: IBookingsConnectionWithTotal
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, IBookingsConnectionWithTotal>({
  handler: (data) => data.viewer.company.bookingConnection,
  name: 'Booking Connection',
})

export default function list(variables: IBookingVariables): Promise<IBookingsConnectionWithTotal> {
  return client.gql.query({ query: bookingListQuery, variables }).then(mutateHandler)
}

export const bookingListQuery = gql`
  query BookingList(
    $after: String
    $first: Int
    $orderBy: BookingOrderByEnum
    $where: BookingWhereInput
  ) {
    viewer {
      company {
        bookingConnection(first: $first, after: $after, orderBy: $orderBy, where: $where) {
          counters {
            total
          }
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...BookingFragment
            }
          }
        }
      }
    }
  }
  ${BookingFragment}
  ${PageInfoFragment}
`
